import styles from './Slogan.module.scss';
import React from 'react';
import { getTranslation } from '../../../../utils/translation';

export default function Slogan() {
    return (
        <div className={styles.slogan}>
            <h1>{getTranslation('login.message.sport')}</h1>
            <h2>{getTranslation('login.message.sportMean')}</h2>
        </div>
    );
}
